import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Button, Empty, Typography } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { api } from '../api'
import { PageLoading } from '../components/ui'
import {
  DedupMatchViewer,
  type DedupMatchSource,
} from '../components/dedup/DedupMatchViewer'
import '../components/dedup/dedupMatchViewer.css'
import './DedupSourceMatches.css'

const { Text } = Typography

type SourceMatchesResponse = {
  report_id: number
  query_title: string
  query_scope: string
  query_original_name?: string
  total_chars?: number
  source: DedupMatchSource
}

export default function DedupSourceMatches() {
  const { reportId, itemId } = useParams()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [payload, setPayload] = useState<SourceMatchesResponse | null>(null)

  useEffect(() => {
    const rid = Number(reportId)
    const sid = Number(itemId)
    if (!rid || !sid) {
      setError('无效的报告或来源编号')
      setLoading(false)
      return
    }
    setLoading(true)
    api
      .get<SourceMatchesResponse>(`/public/dedup/reports/${rid}/sources/${sid}/matches`)
      .then((r) => setPayload(r.data))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false))
  }, [reportId, itemId])

  const closeWindow = () => {
    window.close()
  }

  if (loading) {
    return (
      <div className="dedup-matches-standalone">
        <PageLoading tip="加载片段对照…" />
      </div>
    )
  }

  const source = payload?.source

  return (
    <div className="dedup-matches-standalone">
      <header className="dedup-matches-topbar">
        <div className="dedup-matches-topbar-main">
          <Text strong className="dedup-matches-topbar-title">
            重复片段对照
          </Text>
          {payload && source ? (
            <Text type="secondary" className="dedup-matches-topbar-desc">
              报告 #{payload.report_id} · {source.match_count} 处重复
            </Text>
          ) : null}
        </div>
        <Button type="text" icon={<CloseOutlined />} onClick={closeWindow}>
          关闭
        </Button>
      </header>
      <main className="dedup-matches-body">
        {error ? (
          <Empty description={error} />
        ) : !payload || !source ? (
          <Empty description="未找到该来源的重复片段" />
        ) : (
          <DedupMatchViewer
            variant="standalone"
            queryTitle={payload.query_title}
            queryOriginalName={payload.query_original_name}
            queryScope={payload.query_scope}
            queryTotalChars={payload.total_chars}
            source={source}
          />
        )}
      </main>
    </div>
  )
}
